import { Button, Divider, styled } from '@/theme/index';

export const StyledDrawerButton = styled(Button)(({ theme }) => ({
  fontWeight: 400,
  justifyContent: 'flex-start',
  padding: `${theme.spacing(0.5)} ${theme.spacing(3)}`,
  width: '100%',

  '.MuiButton-startIcon': {
    marginRight: theme.spacing(1.75),
    color: 'rgba(0, 0, 0, 0.56)',

    '.MuiSvgIcon-root': {
      fontSize: '1.5rem',
    },
  },
}));

export const StyledDrawerDivider = styled(Divider)(({ theme }) => ({
  color: theme.palette.secondary.main,
  width: '100%',
  borderWidth: '0.5px',
  margin: `${theme.spacing(1.25)} 0`,
}));
